import React, { Component } from 'react';
import styled from '@emotion/styled';

const BreadcrumbList = styled.ul`
  display: block;
  list-style-type: none;
  margin: 0;
  padding: ${5 / 16}rem ${10 / 16}rem;
  color: ${props => props.theme.lightColor};
  background: ${props => props.theme.secondaryColor};
  font-family: ${props => props.theme.mainFont};
  font-size: ${14 / 16}rem;
  @media (min-width: ${props => props.theme.tablet}) {
    display: inline-block;
    margin-top: ${20 / 16}rem;
    margin-bottom: ${20 / 16}rem;
  }
  @media print {
    display: none;
  }
`;

class Breadcrumb extends Component {
  render() {
    return <BreadcrumbList>{this.props.children}</BreadcrumbList>;
  }
}

export default Breadcrumb;
